import { ApplianceDetailsSteppedMultiPlanFormConfig } from '../../models/appliance-details-stepped-multi-plan/appliance-details-stepped-multi-plan-form-config.interface';
import { mockCmsApplianceDetailsSteppedMultiPlanForm } from './cms-appliance-details-stepped-multi-plan-form.mock';

export const mockApplianceDetailsSteppedMultiPlanFormConfig: ApplianceDetailsSteppedMultiPlanFormConfig =
  {
    applianceMaximumAge: new Date(),
    cmsData: mockCmsApplianceDetailsSteppedMultiPlanForm,
  };
